import React, { ReactElement } from "react";
import { Col, ListGroup, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ProjectTask } from ".";
import { ProjectTaskDueDate } from "./ProjectTaskDueDate";

interface IProps {
	tasks: ProjectTask[];
	emptyMessage: string;
}

export const ProjectTaskList = (props: IProps): ReactElement => {
	const history = useHistory();

	if (!props.tasks.length) {
		return <div className="empty-message">{props.emptyMessage}</div>;
	}

	const taskElements = props.tasks.map((task: ProjectTask, index: number) => {
		return (
			<ListGroup.Item
				className="task-list-item"
				key={index}
				onClick={() => history.push(task.getLink)}
			>
				<Row>
					<Col xs={12} sm={7}>
						{task.name}
					</Col>
					<Col xs={12} sm={2}>
						<ProjectTaskDueDate task={task} dateFormat="MMM D" />
					</Col>
					<Col xs={12} sm={3}>
						<span
							className={`task-project-name project-background-${
								task.project!.color
							}`}
						>
							{task.project!.name}
						</span>
					</Col>
				</Row>
			</ListGroup.Item>
		);
	});

	return <ListGroup className="task-list">{taskElements}</ListGroup>;
};
